module.exports = __webpack_public_path__ + "img/dislike.b2882a9b.svg";